function getToday() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

function isDatePast(date, referenceDate) {
  const msUntil = date - referenceDate;
  const isPast = msUntil < 0;

  return isPast;
}

export default function getOpenHouses(property) {
  const { open_houses: openHouses } = property;

  const today = getToday();

  return openHouses.filter((openHouse) => {
    const { open_house_start_time: startTime } = openHouse;

    return !isDatePast(new Date(startTime), today);
  });
}
